import { render } from "./AlignTopIcon.vue?vue&type=template&id=f669892a"
import script from "./AlignTopIcon.vue?vue&type=script&lang=js"
export * from "./AlignTopIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__